<section class="asterix-wrapper">
    <div class="container" *ngIf="show">
        <div class="asterix-content" [innerHTML]="asterixText">
        </div>
    </div>
</section>